/** START all events */
import * as _ from 'lodash';
import { I18n } from 'react-redux-i18n-lite';
import { updateParticipantsPresence } from '../../actions/presenceActions';
import * as bookActions from '../../actions/bookActions';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as connectionActions from '../../actions/connectionActions';
import * as messageAlert from '../../actions/messageAlertAction';
import * as taskActions from '../../actions/taskActions';
import {
  ROUTES,
  SERVICE_WORKERS,
  ROLE,
  DISCUSSION_TABS_CONSTANTS,
  DISCUSSION_MESSAGES_ORDER_OBJECT,
  MESSAGES_SOCKET
} from '../../const';
import routerHistory from '../../routerHistory';
import { getLogger } from '../../services/logger';
import * as events from './eventNames';
import { synchronizeBookDownload } from '../../actions/contentActions';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import {
  getCurrentDiscussions,
  getFinishedDiscussions,
  getFutureDiscussions,
  setSelectedDiscussion,
  setSelectedDiscussionMessages
} from '../../actions/discussionActions';
import { isFuture } from '../../utils/dateUtlis';
import { getUser } from '../../services/api/userApi';
import * as classroomApi from '../../services/api/classroomApi';

const debug = getLogger('listeners:event:eventListener');

export let start = store => {
  let { dispatch, getState } = store;
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.onmessage = event => {
      debug('Message from SW: %O', event.data);
      if (event.data.type === SERVICE_WORKERS.OFFLINE) {
        dispatch(connectionActions.forceTryToConnect());
      }
    };
  }

  window.addEventListener(events.STUDENT_UPDATE, manageStudentUpdate, false);
  window.addEventListener(events.STUDENT_PRESENCE, manageStudentPresence, false);
  window.addEventListener(events.BOOK.name, _.debounce(manageBookUpdate, 2000), false);
  window.addEventListener(events.USER_GROUP.name, manageUserGroupUpdate, false);
  window.addEventListener(events.CLASSROOM.name, manageClassroomUpdate, false);
  window.addEventListener(events.TASK.name, manageTaskUpdate, false);

  window.addEventListener(events.DISCUSSIONS.UPDATED, manageDiscussionUpdate, false);
  window.addEventListener(events.DISCUSSIONS.DELETED, manageDiscussionDelete, false);
  window.addEventListener(events.DISCUSSIONS.CREATED, manageDiscussionCreation, false);
  window.addEventListener(events.DISCUSSIONS.MESSAGES.CREATED, manageMessageCreation, false);
  window.addEventListener(events.DISCUSSIONS.MESSAGES.UPDATED, manageMessageUpdate, false);

  window.addEventListener(events.STUDENT.name, manageParticipantsUpdate, false);
  window.addEventListener(events.TEACHER.name, manageParticipantsUpdate, false);

  window.addEventListener(events.VIDEOCALL.name, manageVideocallStart, false);
  window.addEventListener(events.GOOGLE.name, manageGoogleCourseworkFinished, false);

  async function manageBookUpdate(event) {
    let data = event.detail;
    let pathname = routerHistory.getCurrentLocation().pathname;

    const ROUTE_CLASSROOM = `${ROUTES.CLASSROOM}/${data.classId}`;
    const ROUTE_CLASSROOM_WORKSPACE = `${ROUTES.CLASSROOM}/${data.classId}/workspace`;
    const ROUTE_CLASSROOM_BOOK = `${ROUTES.CLASSROOM_BOOK.replace('_classId_', data.classId)}/${data.bookId}`;

    if (pathname === ROUTE_CLASSROOM_BOOK) {
      switch (data.action) {
        case events.BOOK.action.ACTIVITY_EDIT:
          const bookInfo = await dispatch(bookActions.getBookInfo(data.classId, data.bookId));
          if (isElectronApp()) {
            dispatch(synchronizeBookDownload(bookInfo, data.classId, data.unitActivityId, false));
          }
          break;
        case events.BOOK.action.BOOK_DELETE:
        case events.BOOK.action.BOOK_VISIBILITY:
          if (getState().account.user.role === ROLE.STUDENT) {
            routerHistory.push(ROUTE_CLASSROOM);
            setTimeout(() => dispatch(messageAlert.error(I18n.t('bookContainer.deleted'))), 1000);
          }
          break;
        default: {
          const bookInfo = await dispatch(bookActions.getBookInfo(data.classId, data.bookId));
          if (events.BOOK.action.BOOK_UNLINKED === data.action) {
            const activityId = data.bookActivityId || (bookInfo && bookInfo.activityId);
            if (activityId) {
              dispatch(bookActions.notifyActivityLinkChanged([activityId]));
            }
          }
          if (isElectronApp()) {
            dispatch(synchronizeBookDownload(bookInfo, data.classId, data.unitActivityId, false));
          }
          break;
        }
      }
    } else if (pathname === ROUTE_CLASSROOM || pathname === ROUTE_CLASSROOM_WORKSPACE) {
      dispatch(bookActions.getBooksData(data.classId));
    } else if (pathname.includes(ROUTE_CLASSROOM_BOOK)) {
      dispatch(bookActions.getBooksData(data.classId));
    } else if (didOpenedTaskChanged(event)) {
      const taskId = getState().task.selectedTask.id;

      dispatch(taskActions.getSelectedTaskWithResults(taskId));
    }
  }

  function manageUserGroupUpdate(event) {
    let data = event.detail;
    switch (data.action) {
      case events.USER_GROUP.action.ASSIGN_STUDENT_TO_BOOK:
        dispatch(bookActions.getBookInfo(data.classId, data.bookId));
        break;
      case events.USER_GROUP.action.UNASSIGN_STUDENT_TO_BOOK:
        dispatch(bookActions.getBookInfo(data.classId, data.bookId));
        break;
      default:
        break;
    }
  }

  function manageClassroomUpdate(event) {
    let data = event.detail;
    let pathname = routerHistory.getCurrentLocation().pathname;

    switch (data.action) {
      case events.CLASSROOM.action.ARCHIVE:
        if (pathname.includes(`/classroom/${data.classId}`)) {
          setTimeout(() => dispatch(messageAlert.error(I18n.t('classroom.archived'))), 1000);
        }
        break;
      default:
        break;
    }
  }

  function manageVideocallStart(event) {
    let data = event.detail;
    let pathname = routerHistory.getCurrentLocation().pathname;

    switch (data.action) {
      case events.VIDEOCALL.action.STARTED:
        if (pathname.includes(`/classroom/${data.classId}`)) {
          setTimeout(() => dispatch(messageAlert.info(I18n.t('videocall.started'))), 1000);
        }
        break;
      default:
        break;
    }
  }

  function manageGoogleCourseworkFinished(event) {
    let data = event.detail;
    // ESTE DATA NO TIENE EL GOOGLERESPONSE
    let pathname = routerHistory.getCurrentLocation().pathname;

    switch (data.action) {
      case events.GOOGLE.action.COURSEWORK_FINISHED:
        if (pathname.includes(`/classroom/${data.sectionId}`)) {
          setTimeout(() => {
            if (data.googleResponseStatus === 200) {
              dispatch(messageAlert.success(I18n.t('common.sharedContentOk')));
            } else if (data.googleResponseStatus === 409) {
              dispatch(messageAlert.error(I18n.t('common.alreadySharedcontent')));
            } else {
              dispatch(messageAlert.error(I18n.t('common.sharedContentFail')));
            }
          }, 1000);
        }
        break;
      default:
        break;
    }
  }

  function manageTaskUpdate(event) {
    let data = event.detail;
    let pathname = routerHistory.getCurrentLocation().pathname;
    const inClassroom = pathname.includes(`/classroom/${data.classId}`);
    const classroomId = data.classId;
    if (inClassroom && classroomId) {
      dispatch(taskActions.getClassroomTasksWithResults(classroomId, data.taskId, data.studentId));
    }
  }

  function manageStudentUpdate(event) {
    let data = event.detail;
    dispatch(classroomActions.updateStudents(data.student, data.classroom));
  }

  function manageStudentPresence(event) {
    const connected = event.detail;
    dispatch(updateParticipantsPresence(connected));
  }

  async function manageParticipantsUpdate(event) {
    const { action, userId, role: participantRole } = event.detail;
    const { _id, role } = getState().account.user;

    const isUnenrollment =
      action === MESSAGES_SOCKET.TEACHER_UNENROLLMENT || action === MESSAGES_SOCKET.STUDENT_UNENROLLMENT;

    if (_id === userId) {
      dispatch(classroomActions.getActiveClassroomData());
      if (!getState().account.jailed) {
        routerHistory.push(ROUTES.HOME);
      }
    } else if (role === ROLE.INSTRUCTOR) {
      if (isUnenrollment) {
        dispatch(
          classroomActions.setClassroomParticipants(
            getState().classrooms.selectedClassroom.participants.filter(participant => participant._id !== userId)
          )
        );
      } else {
        const newParticipant = await getUser(userId).then(res => res.data);
        newParticipant.role = participantRole;
        dispatch(
          classroomActions.setClassroomParticipants([
            ...getState().classrooms.selectedClassroom.participants,
            newParticipant
          ])
        );
      }
    }
  }

  function manageDiscussionCreation(event) {
    const classroomId = getState().router.params.idClassroom;
    const eventDiscussion = event.detail;
    const discussionStatus = getDiscussionStatus(eventDiscussion);

    switch (discussionStatus) {
      case DISCUSSION_TABS_CONSTANTS.FUTURE.key:
        dispatch(getFutureDiscussions(classroomId));
        break;
      case DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key:
        dispatch(getCurrentDiscussions(classroomId));
        break;
      default:
        break;
    }
  }

  function manageDiscussionUpdate(event) {
    const storeDiscussion = getState().discussions.selectedDiscussion.discussion;
    const discussion = event.detail;

    if (discussion.id === storeDiscussion.id) {
      dispatch(setSelectedDiscussion(discussion));
    }
  }

  function manageDiscussionDelete(event) {
    const classroomId = getState().router.params.idClassroom;
    const discussion = event.detail;
    const discussionStatus = getDiscussionStatus(discussion);

    switch (discussionStatus) {
      case DISCUSSION_TABS_CONSTANTS.FUTURE.key:
        dispatch(getFutureDiscussions(classroomId));
        break;
      case DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key:
        dispatch(getCurrentDiscussions(classroomId));
        break;
      case DISCUSSION_TABS_CONSTANTS.FINISHED.key:
        dispatch(getFinishedDiscussions(classroomId));
        break;
      default:
        break;
    }
  }

  function manageMessageCreation(event) {
    const selectedDiscussion = getState().discussions.selectedDiscussion;
    const newMessage = event.detail;

    if (newMessage.discussionId === selectedDiscussion.discussion.id) {
      const messagesOrder = selectedDiscussion.messages.messagesOrder;
      const currentPage = selectedDiscussion.messages.currentPage;
      const totalPages = selectedDiscussion.messages.pages;
      let savedDiscussionMessages = selectedDiscussion.messages.list.slice(0);

      if (newMessage.replyTo) {
        savedDiscussionMessages = addReplyToMessagesList(savedDiscussionMessages, newMessage, messagesOrder);
      } else {
        if (messagesOrder.id === DISCUSSION_MESSAGES_ORDER_OBJECT.NEWER_FIRST.id) {
          savedDiscussionMessages = addMessageToList(savedDiscussionMessages, newMessage, messagesOrder);
        } else if (messagesOrder.id === DISCUSSION_MESSAGES_ORDER_OBJECT.OLDER_FIRST.id) {
          if (totalPages === 0 || currentPage === totalPages - 1) {
            savedDiscussionMessages = addMessageToList(savedDiscussionMessages, newMessage, messagesOrder);
          }
        }
      }
      dispatch(setSelectedDiscussionMessages(savedDiscussionMessages));
    }
  }

  function manageMessageUpdate(event) {
    const updatedMessage = event.detail;
    const selectedDiscussion = getState().discussions.selectedDiscussion;
    if (updatedMessage.discussionId === selectedDiscussion.discussion.id) {
      let discussionMessages = selectedDiscussion.messages.list.slice(0);
      const lists = updateMessagesList(discussionMessages, updatedMessage);
      dispatch(setSelectedDiscussionMessages(lists));
    }
  }

  // Aux functions -----------------------------------------------------------------------------------------------------

  function didOpenedTaskChanged(event) {
    const { content, open } = getState().drawer;

    if (content !== 'STUDENT_TASK' && !open) {
      return;
    }

    const { bookId } = getState().task.selectedTask;
    const { id } = getState().classrooms.selectedClassroom.classroom;

    return bookId === event.detail.bookId && id === event.detail.classId;
  }

  function updateMessagesList(discussionMessages, updatedMessage) {
    return discussionMessages.map(message => {
      if (message.id === updatedMessage.id) {
        return Object.assign(updatedMessage, { replies: message.replies });
      }
      message.replies = message.replies.map(reply => (reply.id === updatedMessage.id ? updatedMessage : reply));
      return message;
    });
  }

  function addReplyToMessagesList(discussionMessages, newMessage, messagesOrder) {
    return discussionMessages.map(message => {
      if (message.id === newMessage.replyTo.id) {
        message.replies = addMessageToList(message.replies, newMessage, messagesOrder);
      } else if (message.replies.find(reply => reply.id === newMessage.replyTo.id)) {
        message.replies = addMessageToList(message.replies, newMessage, messagesOrder);
      }
      return message;
    });
  }

  function addMessageToList(messages, newMessage, messagesOrder) {
    const messagesArray = messages.slice(0);
    if (messagesOrder.id === DISCUSSION_MESSAGES_ORDER_OBJECT.NEWER_FIRST.id) {
      messagesArray.unshift(newMessage);
    } else if (messagesOrder.id === DISCUSSION_MESSAGES_ORDER_OBJECT.OLDER_FIRST.id) {
      messagesArray.push(newMessage);
    }
    return messagesArray;
  }

  function getDiscussionStatus(discussion) {
    if (isFuture(discussion.startDate)) {
      return DISCUSSION_TABS_CONSTANTS.FUTURE.key;
    }
    if (isFuture(discussion.dueDate)) {
      return DISCUSSION_TABS_CONSTANTS.IN_PROGRESS.key;
    }
    return DISCUSSION_TABS_CONSTANTS.FINISHED.key;
  }
};
